export type BookingReturnOrigin = 'requests' | 'service-calls' | undefined;

export function bookingReturnDestination(scheduled: boolean, origin: BookingReturnOrigin) {
  if (!scheduled) return '/dashboard/unscheduled' as const;
  return origin === 'service-calls'
    ? ('/dashboard/jobs/service-calls' as const)
    : ('/dashboard/bookings' as const);
}
